import {Component, Input} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {AgreementVerificationType, Property} from '@aztrix/models';
import {ProposalRepresentation} from '@aztrix/sdk';

@Component({
  selector: 'ax-proposal-verification-form',
  templateUrl: './proposal-verification-form.component.html',
  styleUrls: ['./proposal-verification-form.component.scss'],
})
export class ProposalVerificationFormComponent {
  @Input() form: UntypedFormGroup;
  @Input() possibleProperties: Property[];
  @Input() showLabel = true;
  @Input() verificationType?: AgreementVerificationType | ProposalRepresentation.VerificationEnum;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  AgreementVerificationType = AgreementVerificationType;

  get propertyControl() {
    return this.form?.get('property');
  }
}
